import styled, { keyframes } from "styled-components"
import TechnologyIcons from "./technologyIcons"

export const Wrapper = styled.div`
  width: 90%;
  height: 80vh;
  padding: 5rem 0;
  margin: 0 auto;
  overflow: hidden;
  @media (max-width: 900px) {
    width: 100%;
  }
`
const numberIcons = TechnologyIcons.length
const containerWidth = 10 * numberIcons * 2
const animationWindowWidth = -1 * (containerWidth / 2)
const time = numberIcons * 2

export const ScrollIcons = keyframes`
    0%{
      transform: translateX(0vw);
    }

  100% {
      transform: translateX(${animationWindowWidth}vw);
    }

`
export const IconsContainer = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  width: ${containerWidth}vw;
  height: 80%;
  animation: ${ScrollIcons} ${time}s linear infinite;
  transition: all 0.3s ease-in-out;

  & div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & span {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    padding: 1rem 2rem;
    font-size: 5rem;
    white-space: nowrap;
    width: max(120px, 10vw);
    fill: ${({ color }) => color};
    transition: all 0.3s ease-in-out;

    &:hover {
      transform-origin: center;
      transform: scale(1.4) rotate(9deg);
    }
  }
  @media (max-width: 1100px) {
    width: 480%;
    animation: scrollLeftMediumWindow 24s linear infinite;
    & span {
      width: 15vw;
      padding: 1rem 1.4rem;
    }
  }
  @media (max-width: 600px) {
    width: 736%;
    animation: scrollLeftSmallWindow 20s linear infinite;
    & span {
      width: 23vw;
      padding: 0.5rem 1.2rem 1.4rem;
    }
  }

  &:hover {
    animation-play-state: paused;
  }

  @keyframes scrollLeftMediumWindow {
    from {
      transform: translateX(0vw);
    }

    to {
      transform: translateX(-240vw);
    }
  }
  @keyframes scrollLeftSmallWindow {
    from {
      transform: translateX(0vw);
    }

    to {
      transform: translateX(-368vw);
    }
  }
`
